import { Survey, SurveyStatusInfo } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

/**
 * Whether the survey on screen may have its estimates recomputed.
 *
 * A survey past draft is only ever edited from the Manage Survey audience
 * drawer, and none of the derived estimates (feasibility, score, flexibility
 * prices, supplier blends, similar surveys) are rendered there — so recomputing
 * them is pure waste.
 *
 * Reads as the draft case before a survey has loaded: no recalculation trigger
 * can fire until one arrives.
 */
export function allowsAudienceRecalculation(survey: Nullable<Survey>): boolean {
  return SurveyStatusInfo.isDraftOrAbsent(survey);
}
